<template>
    <div class="chat">
        <div
                class="chat__history"
                :class="{
                    'chat__history_scroll-block': scrollBlocking
                }"
                ref="chatHistory"
                @scroll="changeScroll($event)"
        >
            <message
                    v-for="(model, key) in messages"
                    :key="key"
                    :model="model"
                    class="chat__item"
                    :my-types="myTypes"
                    :data-message-id="model.id"
            ></message>
        </div>
        <div class="chat__type">
            <textarea-autosize
                    v-model="msg"
                    class="chat__input"
                    :placeholder="$t('msg.message')"
                    :min-height="30"
                    rows="1"
                    @keydown.native="keyboard($event)"
                    ref="input"
            ></textarea-autosize>
            <div
                    class="chat__send"
                    :class="{
                            'chat__send_loading': loading
                        }"
                    @click="send()"
            >
                <v-icon v-if="!loading">mdi-send</v-icon>
                <v-icon v-if="loading">mdi-loading</v-icon>
            </div>
        </div>
    </div>
</template>

<script>
    import Message from "./Message";
    import TextareaAutosize from "../TextareaAutosize";

    export default {
        components: {Message, TextareaAutosize},
        props: {
            messages: {type: Array, default: () => []},
            correctionScroll: {type: Number, default: 80},
            myTypes: {type: Array, default: () => []}
        },
        data() {
            return {
                scrollBlocking: false,
                msg: null,
                loading: false
            };
        },
        methods: {
            scrollToBottom() {
                this.$nextTick(() => {
                    this.$refs.chatHistory.scrollTop = this.$refs.chatHistory.scrollHeight;
                });
            },
            changeScroll(event) {
                if (event.target.scrollTop === 0) {
                    this.$emit('scroll-top');
                }
            },
            scrollToMessage(id) {

                this.$nextTick(() => {
                    let el = this.$refs.chatHistory.querySelector('[data-message-id="'+id+'"]');
                    this.$refs.chatHistory.scrollTop = el.offsetTop - this.correctionScroll;
                });
            },
            send() {
                if (this.loading) return;
                if (this.msg === null || this.msg === '') return;

                this.$emit('send', this.msg);
                this.msg = null;
                this.loading = true;
            },
            keyboard(event) {
                if (event.keyCode === 13 && event.ctrlKey) {
                    this.msg += "\n";
                } else if (event.keyCode === 13) {
                    event.preventDefault();
                    this.send();
                }
            },
        }
    }
</script>

<style lang="scss">
    .chat {
        height: 100%;

        .chat__history {
            height: 100%;
            overflow-y: scroll;
            padding: 20px;

            &.chat__history_scroll-block {
                overflow-y: hidden;
            }
        }
        .chat__item {
            margin-top: 10px;

            &:first-child {
                margin-top: 0;
            }
        }
        .chat__type {
            height: 56px;
            background: rgb(244, 247, 249);
            display: flex;
            align-items: center;
            padding: 10px 5px;
        }
        .chat__send {
            width: 36px;
            height: 36px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
                opacity: 0.7;
            }
            &.window-chat__send_loading {
                cursor: default;

                .v-icon {
                    animation-name: rotation;
                    animation-duration: 1s;
                    animation-iteration-count: infinite;
                    animation-timing-function: linear;
                }
            }
            .v-icon {
                transform: rotate(-45deg);
                margin-top: -5px;
            }
        }
        .chat__input {
            width: 100%;
            max-height: 94px;
            padding: 6px 15px;
            font-size: 13px !important;
            flex: 1;
            overflow-y: auto;
            outline: none;
        }
    }
</style>